export default {
  getHead: () => {
    return [{ name: '사업장명' }, { name: '회의구분' }, { name: '평가차수' }, { name: '회의일' }, { name: '회의장소' }, { name: '참석업체' }, { name: '소속명' }, { name: '부서명' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContent(value).checkType // 회의구분
      case 2: return func.getContent(value).inputB_1 // 평가차수
      case 3: return func.getContent(value).inputB_4 // 회의일
      case 4: return func.getContent(value).inputB_5 // 회의장소
      case 5: return func.getContent(value).inputB_7 // 참석업체
      case 6: return func.getContent(value).stdInfo.department // 소속명
      case 7: return func.getContent(value).stdInfo.section // 부서명
      case 8: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case '사업장명': return ['content$body.stdInfo.field_name*%[:default_skw]%']
    case '회의구분': return ['content$body.checkType*%[:default_skw]%']
    case '평가차수': return ['content$body.inputB_1*%[:default_skw]%']
    case '회의일': return ['content$body.inputB_4*%[:default_skw]%']
    case '회의장소': return ['content$body.inputB_5*%[:default_skw]%']
    case '참석업체': return ['content$body.inputB_7*%[:default_skw]%']
    case '소속명': return ['content$body.stdInfo.department*%[:default_skw]%']
    case '부서명': return ['content$body.stdInfo.section*%[:default_skw]%']
    }

    return []
  },
}
